import React from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
export default function Card(props) {
  return (
    <>
      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <div
          className="card custom-card"
          style={{ borderBottom: "2px solid rgb(184, 184, 63)" }}
        >
          <div className="card-body">
            <div className="card-item">
              <div className="card-item-icon card-icon">
                <i
                  style={{
                    background:
                      "linear-gradient(135deg, #37d4cc, #5098c8ff, #043949ff, #011f29ff)",
                    // background:"linear-gradient(135deg, #D4AF37, #50C878, #004225)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontSize: "40px",
                    color: "white",
                  }}
                  className={props.icon}
                ></i>
              </div>
              <div className="card-item-title mb-2">
                <label className="main-content-label tx-13 font-weight-bold mb-1">
                  {props.details}
                </label>
                <span className="d-block tx-12 mb-0 text-muted">
                  {props.details1}
                </span>
              </div>
              <div className="card-item-body">
                <div className="card-item-stat">
                  <h4 className="font-weight-bold">{props.value}</h4>
                  <small>
                    <b
                      className={
                        props.percd === "d" ? "text-danger" : "text-success"
                      }
                    >
                      {props.perc}%
                    </b>
                    {props.percd === "d" ? "decrease" : "increase"}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
